import React from "react";

import type { CmLineMarker } from "models";

export type LineMarkerTone = "positive" | "negative" | "neutral";

const TONE_CLASS: Record<LineMarkerTone, string> = {
  positive: "every-line-marker-positive",
  negative: "every-line-marker-negative",
  neutral: "every-line-marker-neutral",
};

type LineMarkerProps = {
  marker: CmLineMarker;
  /** Green when the line raises the compared scenario's margin, red when it lowers it; neutral in the key. */
  tone?: LineMarkerTone;
  /** Read out instead of the pattern, e.g. "Estimated by the model". */
  screenReaderText?: string;
};

/** Hatched for the model's estimate, dashed outline for a price trend; farm-account lines keep an empty slot so labels align. */
export const LineMarker = ({ marker, tone = "neutral", screenReaderText }: LineMarkerProps) => (
  <>
    <span aria-hidden className={`every-line-marker every-line-marker--${marker} ${TONE_CLASS[tone]}`} />
    {screenReaderText ? <span className="every-line-visually-hidden">{screenReaderText}</span> : null}
  </>
);

export default LineMarker;
